/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APISupplier } from './APISupplier';
import {
    APISupplierFromJSON,
    APISupplierFromJSONTyped,
    APISupplierToJSON,
} from './APISupplier';

/**
 * 
 * @export
 * @interface APIPaginatedSupplierList
 */
export interface APIPaginatedSupplierList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedSupplierList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedSupplierList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedSupplierList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APISupplier>}
     * @memberof APIPaginatedSupplierList
     */
    results: Array<APISupplier>;
}

/**
 * Check if a given object implements the APIPaginatedSupplierList interface.
 */
export function instanceOfAPIPaginatedSupplierList(value: object): value is APIPaginatedSupplierList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedSupplierListFromJSON(json: any): APIPaginatedSupplierList {
    return APIPaginatedSupplierListFromJSONTyped(json, false);
}

export function APIPaginatedSupplierListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedSupplierList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APISupplierFromJSON)),
    };
}

export function APIPaginatedSupplierListToJSON(value?: APIPaginatedSupplierList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APISupplierToJSON)),
    };
}

